import * as React from 'react'
import { ConfirmationModalProps } from './useUnsavedChangesModal'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

const ConfirmationdModal: React.FC<ConfirmationModalProps> = (props) => {
    const generateDialogFooter = () => {
        return (
            <>
                <StyledButton
                    variant="outlined"
                    color="secondary"
                    invert
                    onClick={props.onClose}
                >
                    {props.closeBtnLabel}
                </StyledButton>
                <StyledButton color="error" onClick={props.onConfirm}>
                    {props.confirmBtnLabel}
                </StyledButton>
            </>
        )
    }

    return (
        <AppDialog
            aria-labelledby="contained-modal-title-vcenter"
            open
            maxWidth={'sm'}
            fullWidth
            title={props.title}
            onClose={props.onClose}
            headerClose={props.onClose}
            contentProps={{ dividers: true }}
            actions={generateDialogFooter()}
        >
            {props.content}
        </AppDialog>
    )
}

export default ConfirmationdModal
